import * as Yup from "yup"
import { Paragraph } from "../Components/Paragraph"

export const selfInitiatedFlowSteps = (user) => {
  const hasMultipleOrgs = user?.organizations?.length > 1

  return [
  {
    id: "basic_info",
    encouragement: "👋",
    encouragementClassName: "text-4xl",
    title:'Let\'s get started!',
    renderCustomContent: () => (
      <div className="py-8 text-center">
        <Paragraph>What is your student&apos;s first and last name?</Paragraph>
      </div>
    ),
    fields: [
      {
        fieldType: "text",
        fieldName: "student_first_name",
        label: "Student's First Name",
        fieldProps: { placeholder: "First name (e.g., Jordan)" },
        required: true,
      },
      {
        fieldType: "text",
        fieldName: "student_last_name",
        label: "Student's Last Name",
        fieldProps: { placeholder: "Last name (e.g., Brown)" },
        required: true,
      },
      ...(hasMultipleOrgs ? [{
        fieldType: "select",
        fieldName: "organization_id",
        label: "Organization",
        required: true,
        fieldProps: {
          options: user.organizations.map(org => ({
            value: org.id,
            label: org.name,
          })),
          placeholder: "Select an organization",
        },
      }] : []),
    ],
    validation: Yup.object({
      student_first_name: Yup.string().required("Please enter a student's first name"),
      student_last_name: Yup.string().required("Please enter a student's last name"),
      ...(hasMultipleOrgs ? {
        organization_id: Yup.string().required("Please select an organization"),
      } : {}),
    }),
  },
  {
    id: "plan_name",
    title: "Name your student's Mentor Circle Plan",
    fieldType: "text",
    fieldName: "plan_name",
    width: "w-96",
    fieldProps: {
      placeholder: "Enter a name for your plan",
    },
    getInitialValues: values => ({
      plan_name: values.student_first_name
        ? `${values.student_first_name}'s Mentor Circle Plan - ${new Date().getFullYear()}`
        : "My Mentor Circle Plan",
    }),
    validation: Yup.object({
      plan_name: Yup.string().required("Please enter a plan name"),
    }),
    contentAfterField: true,
    renderCustomContent: () => (
      <div className="py-8 text-center">
        <p>You can update this name anytime after setup.</p>
      </div>
    ),
  },
  ]
}

export const selfInitiatedInitialValues = {
  student_first_name: "",
  student_last_name: "",
  plan_name: "",
  organization_id: null,
}
